import { CLOUD, loggedIn, sbRest, sbUrl } from '../cloud/api.js';
import { t } from '../i18n/index.js';
import { copyText } from '../messaging.js';
import { IC, ask, closeSheet, sheet, toast } from '../ui.js';

/* Secret calendar link: Google/Apple/Outlook subscribe once and stay current.
   The feed itself is served by supabase/functions/notify (route /ics/<token>.ics). */
const feedUrl=tok=>sbUrl('/functions/v1/notify/ics/'+tok+'.ics');
async function current(){const r=await sbRest('calendar_feeds?select=token&order=created_at.desc&limit=1');const rows=await r.json();return rows&&rows[0]?rows[0].token:null}
async function create(){
  const r=await sbRest('calendar_feeds',{method:'POST',headers:{Prefer:'return=representation'},body:JSON.stringify({org_id:CLOUD.org})});
  const rows=await r.json();return rows[0].token;
}
export async function openFeedSheet(){
  if(!loggedIn()||!CLOUD.org){toast(t('n.needLogin'));return}
  let tok;
  try{tok=(await current())||(await create())}catch(e){console.error('feed',e);toast(t('feed.err'));return}
  const b=sheet(`<div class="sheethead"><h2>${t('feed.title')}</h2><button class="iconbtn" data-a="x" aria-label="${t('c.close')}">${IC.x}</button></div>
  <div class="sheetbody">
    <p class="muted mb">${t('feed.body')}</p>
    <div class="row mb" style="gap:8px">
      <a class="btn primary" id="fd-g" target="_blank" rel="noopener">${IC.cal} ${t('feed.google')}</a>
      <a class="btn" id="fd-w">${IC.cal} ${t('feed.apple')}</a>
    </div>
    <div class="feedrow"><input class="input" id="fd-url" readonly aria-label="${t('feed.title')}"><button class="btn" data-a="copy">${IC.copy} ${t('feed.copy')}</button></div>
    <p class="tiny mt">${t('feed.private')} <button class="linkbtn" data-a="reset">${t('feed.reset')}</button></p>
  </div>`);
  const q=x=>b.querySelector(x);
  const fill=()=>{
    const u=feedUrl(tok),w=u.replace(/^https?:/,'webcal:');
    q('#fd-url').value=u;q('#fd-g').href='https://calendar.google.com/calendar/r?cid='+encodeURIComponent(w);q('#fd-w').href=w;
  };
  fill();
  q('[data-a=x]').onclick=()=>closeSheet(b);
  q('[data-a=copy]').onclick=()=>copyText(feedUrl(tok));
  q('#fd-url').onclick=e=>e.target.select();
  q('[data-a=reset]').onclick=()=>ask(t('feed.resetAsk'),async()=>{
    try{await sbRest('calendar_feeds?token=eq.'+tok,{method:'DELETE'});tok=await create();fill();toast(t('feed.resetDone'))}
    catch(e){toast(t('feed.err'))}
  },true);
}
